import React, { Component } from 'react';
import UserDesc from 'components/UserDesc';
import UserInfo from 'components/UserInfo';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import styles from './ProfileData.scss';// to import local scss fle

class ProfileData extends Component {
  static propTypes = {
    removeVideoScreen: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  render() {
    return (
      <div className={cn('row', styles.profileDataContainer)}>
        <div className={cn('col s12', styles.dataInBigScreens)}>
          <div className={cn('col s6', styles.userDescription)}>
            <UserDesc {...this.props} removeVideoScreen={this.props.removeVideoScreen} />
          </div>
          <div className={cn('col s6', styles.userInfo)}>
            <UserInfo {...this.props} />
          </div>
        </div>
        <div className={cn('col s12', styles.dataInSmallScreens)}>
          <div className={cn('col s12', styles.userInfo)}>
            <UserInfo {...this.props} />
          </div>
          <div className={cn('col s12', styles.userDescription)}>
            <UserDesc {...this.props} />
          </div>

        </div>

      </div>
    );
  }
}


export default ProfileData;



// WEBPACK FOOTER //
// ./src/components/ProfileData/ProfileData.js